import { render, staticRenderFns } from "./appointments_tabs.vue?vue&type=template&id=db3875f4"
import script from "./appointments_tabs.vue?vue&type=script&lang=js"
export * from "./appointments_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports